import { request } from "../axios/request";

export const getSitesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/sites", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAllSitesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/sites", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveSiteService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/sites/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/sites", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteSiteService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/sites/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
